import { createSlice } from "@reduxjs/toolkit";
import { apiGetOurClients } from "../helpers/backend_helper";

const clientSlice = createSlice({
    name : 'slice',
    initialState  : {
        data : [],
        loading : false,
        error : null,
    },
    reducers : {
        fetchClientsRequest(state){
            state.loading = true;
            state.error = null;
        },
        fetchClientSuccess(state,action){
            state.loading = false;
            state.data = action.payload;
        },
        fetchClientFailure(state, action){
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {fetchClientsRequest, fetchClientSuccess, fetchClientFailure} = clientSlice.actions;

export const fetchClientData = () => async(dispatch) => {
    dispatch(fetchClientsRequest());
    try{
        const response = await apiGetOurClients();
        dispatch(fetchClientSuccess(response.results.data));
    }
    catch(error){
        dispatch(fetchClientFailure(error.message || 'Failed to fetch Client Details'));
    }
}

export default clientSlice.reducer;